import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";

import './games.css';
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { api } from "../../../index";

export default function Games() {
    const [deckSelected, setDeckSelected] = useState<string | undefined>(
        undefined
    );
    const [decks, setDecks] = useState<
        Array<{ deck_id: string; deck_name: string }>
    >([]);
    const navigate = useNavigate();

    useEffect(() => {
        api
            .post('/decks/validate', {}, { withCredentials: true })
            .then((res) => {
                setDecks(res.data);
            })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    window.location.href = '/logout';
                }
            });
    }, []);

    return (
        <Container className="my-4 pt-2 pb-2">
            <Row className='mb-4 align-items-center'>
                <Col>
                    <h2 className='mb-0'>Play Game</h2>
                    <p className='text-muted'>Select a deck and join a game</p>
                </Col>
                <Col xs='auto'>
                    <Link to='/home' className='btn btn-outline-secondary btn-sm'>
                        Back to Home
                    </Link>
                </Col>
            </Row>
            <Row className="g-4">
                {/* Deck Selector Column */}
                <Col xs={12} md={6}>
                    <Row className="g-2">
                        {decks.length === 0 && (
                            <Col xs={12}>
                                <Alert variant="info" className="mb-0">
                                    No decks found. Please create a deck.
                                </Alert>
                            </Col>
                        )}
                        {decks.map((deck) => (
                            <Col key={deck.deck_id} xs={12} sm={6} lg={4}>
                                <Card
                                    className={`h-100 shadow-sm d-flex flex-column ${deck.deck_id === deckSelected ? 'border-primary' : ''
                                        }`}
                                    onClick={() => setDeckSelected(deck.deck_id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Card.Body className="d-flex flex-column justify-content-center">
                                        <Card.Title className="text-center mb-0">
                                            {deck.deck_name}
                                        </Card.Title>
                                    </Card.Body>
                                    <Card.Footer
                                        className={`text-center ${deck.deck_id === deckSelected
                                            ? 'bg-primary text-white'
                                            : 'bg-light text-muted'
                                            }`}
                                    >
                                        {deck.deck_id === deckSelected ?
                                            'Selected'
                                            : '\u00A0'}
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>

                {/* Game Actions Column */}
                <Col xs={12} md={6}>
                    <Row className="g-2">
                        <Col xs={12}>
                            <Button
                                variant="primary"
                                className="w-100 shadow-sm py-3"
                                onClick={() => {
                                    navigate(`/games/waiting/${deckSelected}`);
                                }}
                                disabled={deckSelected === undefined}
                            >
                                Join A Random Game
                            </Button>
                        </Col>
                        {/* <Col xs={12}>
              <Button
                variant="secondary"
                className="w-100 shadow-sm py-3"
                onClick={() => {
                  navigate(`/games/create/${deckSelected}`);
                }}
                disabled={deckSelected === undefined}
              >
                Host a Private Game
              </Button>
            </Col>
            <Col xs={12}>
              <Button
                variant="info"
                className="w-100 shadow-sm py-3"
                onClick={() => {
                  navigate(`/games/join/${deckSelected}`);
                }}
                disabled={deckSelected === undefined}
              >
                Join A Private Game
              </Button>
            </Col> */}
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}